/* eslint-disable @typescript-eslint/member-delimiter-style */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable no-nested-ternary */
import React, { FC, useState } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import _ from 'lodash'
import { ListItem, ListItemText, Divider } from '@material-ui/core'
import { inject, observer } from 'mobx-react'
import { Prospects as ProspectsStore, MultiTemplate } from '../../../../../stores/prospects'
import { Settings as SettingsStore } from '../../../../../stores/settings'
import Spinner from '../../../../Spinner'
import TouchesForm from './TouchesForm'
import './styles.scss'

interface Props extends RouteComponentProps {
  prospects?: ProspectsStore
  settings?: SettingsStore
  currentType: string
}

const TemplatesModal: FC<Props> = props => {
  const [currentCampaignIndex, setCurrentCampaignIndex] = useState(0)
  const { prospects, currentType } = props
  const handleCampaignChange = (newValue: number): void => {
    setCurrentCampaignIndex(newValue)
  }

  const getCampaign = (campaign: string): string => {
    if (campaign === 'Current Mission') {
      return campaign
    }
    return [campaign.slice(0, campaign.length - 1), '#', campaign.slice(-1)].join('')
  }

  let emailTemplates: MultiTemplate | undefined = {}

  if (prospects?.isLoading) {
    return (
      <div className="touches w-100">
        <Spinner />
      </div>
    )
  }
  if (prospects?.prospect) {
    switch (currentType) {
      case 'Rev-Up':
        emailTemplates = prospects.prospect.firstTouchTemplates
        break
      case 'Engaged':
        emailTemplates = prospects.prospect.followUpTemplates
        break
      case 'Re-Engaged':
      default:
        emailTemplates = prospects.prospect.nurtureTemplates
    }
  }
  const sortedEmailTemplateOptions = _.keys(emailTemplates).sort()

  return (
    <div className="touches w-100 overflow-auto">
      <Divider />
      <div className="modal_section">
        {sortedEmailTemplateOptions.map((campaign, index) => (
          <ListItem
            button
            className={`mav-modal-title ${currentCampaignIndex === index ? 'active' : ''}`}
            key={campaign}
            onClick={(): void => handleCampaignChange(index)}
          >
            <ListItemText primary={getCampaign(campaign)} />
          </ListItem>
        ))}
      </div>
      <Divider />
      {sortedEmailTemplateOptions.map((campaign, index) => {
        const templates =
          currentType === 'Rev-Up'
            ? prospects?.prospect?.firstTouchTemplates[campaign]
            : currentType === 'Engaged'
            ? prospects?.prospect?.followUpTemplates[campaign]
            : prospects?.prospect?.nurtureTemplates[campaign]
        const daysBetween =
          currentType === 'Rev-Up'
            ? prospects?.prospect?.firstTouchDaysBetween[campaign]
            : currentType === 'Engaged'
            ? prospects?.prospect?.followUpDaysBetween[campaign]
            : prospects?.prospect?.nurtureDaysBetween[campaign]
        const menuverType =
          currentType === 'Rev-Up'
            ? 'First Touch'
            : currentType === 'Engaged'
            ? 'Follow Up'
            : 'Nurture'
        if (currentCampaignIndex === index) {
          return (
            <TouchesForm
              key={campaign}
              maneuverType={menuverType}
              campaign={campaign}
              templates={templates}
              daysBetween={daysBetween}
            />
          )
        }
        return <div key={campaign} />
      })}
    </div>
  )
}

export default inject('settings')(observer(TemplatesModal))
